/*! @azure/msal-common v4.4.0 2021-06-29 */
'use strict';
/* eslint-disable header/header */

var name = "@azure/msal-common";
var version = "4.4.0";
export { name, version };